import React from 'react';
import Keyboard from "react-simple-keyboard";
import "./react-simple-keyboard.css";
import Box from "@mui/material/Box";

const CustomNumericKeyboard = ({onChange, onKeyPress}) => {

    return (
        <Box sx={{width: '100vw'}}>
            <Keyboard
                onChange={onChange}
                layout={
                    {
                        default: ["1 2 3", "4 5 6", "7 8 9", "{clear} 0 {bksp}"]
                    }
                }
                mergeDisplay
                display={{
                    "{clear}": "Clear",
                    "{bksp}": "&#8592"
                }}
                maxLength={5}
                theme={
                    "hg-theme-default hg-theme-numeric hg-layout-numeric numeric-theme custom-theme"
                }
            />
        </Box>
    );
};

export default CustomNumericKeyboard;